<template>
  <div class="">
    <div class="text-gray-100 mt-10" v-if="apuestaError">{{ apuestaError }}</div>
    <div class="bg-white m-5 rounded-md shadow-lg">
      <div class="font-mono px-3 pt-3 font-bold text-right">Nº: {{ datosApuesta.numeroTicket }}</div>
      <div class="font-mono px-3 text-right text-sm">{{ format(parseISO(datosApuesta.fechaHora), "dd/MM/yyyy HH:mm:ss") }}</div>
      <div class="font-mono px-3 text-left">{{ datosApuesta.carreraSeleccionada.hipodromo }}</div>
      <div class="font-mono px-3 text-left">Carrera: {{ datosApuesta.carreraSeleccionada.numero }}</div>
      <div class="font-mono px-3 text-left">{{ datosApuesta.cantidadVales }}v x {{ datosApuesta.tipoApuestaSeleccionada.id }} {{ datosApuesta.textoApuesta }}</div>
      <div class="font-mono px-3 text-right text-sm">Apuesta: {{ currency(datosApuesta.importeApuesta, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Impuestos: {{ currency(datosApuesta.importeImpuestos, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Bonificacion: {{ currency(datosApuesta.importeBonificacion, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Servicio: {{ currency(datosApuesta.importeComision, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right font-bold text-xl">Total: {{ currency(datosApuesta.importeTotal, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-left text-xs">P. Max(x$): {{ currency(datosApuesta.tipoApuestaSeleccionada.pagoMaximo, { decimal: "," }).format() }}</div>
    </div>
    <button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button>
    <button @click="copiarPortapapeles" class="ml-2 bg-paleta-2 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Copiar</button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import currency from "currency.js";
import { parseISO, format } from "date-fns";

export default {
  data() {
    return {
      currency,
      parseISO,
      format
    };
  },
  methods: {
    inicio: function() {
      this.$store.dispatch("eliminarDatosApuestaActual");
      this.$router.push("/menu");
    },
    copiarPortapapeles() {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value =
        "Nº " +
        this.datosApuesta.numeroTicket +
        "\n" +
        format(parseISO(this.datosApuesta.fechaHora), "dd/MM/yyyy HH:mm:ss") +
        "\n" +
        this.datosApuesta.carreraSeleccionada.hipodromo +
        "\n" +
        "Carrera: " +
        this.datosApuesta.carreraSeleccionada.numero +
        "\n" +
        this.datosApuesta.cantidadVales +
        "v x " +
        this.datosApuesta.tipoApuestaSeleccionada.id +
        " " +
        this.datosApuesta.textoApuesta +
        "\n" +
        "Apuesta: " +
        this.currency(this.datosApuesta.importeApuesta, { decimal: "," }).format() +
        "\n" +
        "Impuestos: " +
        this.currency(this.datosApuesta.importeImpuestos, { decimal: "," }).format() +
        "\n" +
        "Bonificacion: " +
        this.currency(this.datosApuesta.importeBonificacion, { decimal: "," }).format() +
        "\n" +
        "Servicio: " +
        this.currency(this.datosApuesta.importeComision, { decimal: "," }).format() +
        "\n" +
        "Total: " +
        this.currency(this.datosApuesta.importeTotal, { decimal: "," }).format();
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  },
  computed: {
    ...mapState({
      saldo: state => state.sesion.usuario.saldo,
      datosApuesta: state => state.apuestaActual,
      apuestaError: state => state.apuestaActual.mensaje
    })
  }
};
</script>
